import { useState, useEffect } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Panel } from "@/components/common";
import { UserCircle, Lock, ShieldCheck } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function MyAccount() {
  const { logout } = useAuth();
  const [me, setMe] = useState(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [cur, setCur] = useState("");
  const [np, setNp] = useState("");
  const [cp, setCp] = useState("");

  useEffect(() => { api.get("/account").then(({ data }) => { setMe(data); setName(data.name || ""); setEmail(data.email || ""); }); }, []);

  const saveProfile = async () => {
    try { const { data } = await api.patch("/account", { name, email }); toast.success("Profile updated"); if (data.email !== me.email) toast("Email changed — use it next login"); setMe({ ...me, name, email }); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  const savePassword = async () => {
    if (np !== cp) { toast.error("New passwords do not match"); return; }
    try { await api.patch("/account", { current_password: cur, new_password: np }); toast.success("Password changed. Old password no longer works."); setCur(""); setNp(""); setCp(""); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  if (!me) return null;

  return (
    <div>
      <PageHeader icon={UserCircle} title="My Account"
        subtitle="Manage your profile, email and password. Passwords are securely hashed and never displayed." />

      <div className="grid lg:grid-cols-2 gap-6">
        <Panel>
          <div className="flex items-center gap-2 mb-4"><UserCircle size={18} weight="duotone" className="text-[#00E5FF]" /><span className="font-display font-bold text-white">Profile</span></div>
          <label className="block text-xs text-zinc-500 mb-1">Display name</label>
          <input data-testid="acc-name" value={name} onChange={(e) => setName(e.target.value)} className="w-full mb-3 rounded-xl bg-black/30 border border-white/10 px-4 py-2.5 text-white outline-none focus:border-[#00E5FF]/50" />
          <label className="block text-xs text-zinc-500 mb-1">Email (login)</label>
          <input data-testid="acc-email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mb-4 rounded-xl bg-black/30 border border-white/10 px-4 py-2.5 text-white outline-none focus:border-[#00E5FF]/50" />
          <button data-testid="acc-save" onClick={saveProfile} className="rounded-full bg-magic px-5 py-2.5 text-sm font-semibold text-black">Save Profile</button>
        </Panel>

        <Panel>
          <div className="flex items-center gap-2 mb-4"><Lock size={18} weight="duotone" className="text-[#FF007F]" /><span className="font-display font-bold text-white">Change Password</span></div>
          <input data-testid="acc-cur" type="password" placeholder="Current password" value={cur} onChange={(e) => setCur(e.target.value)} className="w-full mb-3 rounded-xl bg-black/30 border border-white/10 px-4 py-2.5 text-white outline-none" />
          <input data-testid="acc-new" type="password" placeholder="New password" value={np} onChange={(e) => setNp(e.target.value)} className="w-full mb-3 rounded-xl bg-black/30 border border-white/10 px-4 py-2.5 text-white outline-none" />
          <input data-testid="acc-confirm" type="password" placeholder="Confirm new password" value={cp} onChange={(e) => setCp(e.target.value)} className="w-full mb-4 rounded-xl bg-black/30 border border-white/10 px-4 py-2.5 text-white outline-none" />
          <button data-testid="acc-savepw" onClick={savePassword} className="rounded-full bg-magic px-5 py-2.5 text-sm font-semibold text-black">Change Password</button>
        </Panel>
      </div>

      <Panel className="mt-6 flex items-center gap-3">
        <ShieldCheck size={20} weight="duotone" className="text-[#00FF9D]" />
        <p className="text-sm text-zinc-400 flex-1">Sessions & security. Architecture is ready for 2FA, Google login and passkeys (not enabled yet).</p>
        <button onClick={logout} className="rounded-full border border-[#FF3366]/40 text-[#FF3366] px-4 py-2 text-sm">Sign out</button>
      </Panel>
    </div>
  );
}
